package com.eladfinish.bible.contest

import dev.icerock.moko.graphics.Color
import dev.icerock.moko.resources.AssetResource
import dev.icerock.moko.resources.ColorResource
import dev.icerock.moko.resources.FileResource
import dev.icerock.moko.resources.FontResource
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.ResourceContainer
import dev.icerock.moko.resources.ResourcePlatformDetails
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.RemoteJsStringLoaderHolder
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public actual object SharedRes {
  public const val contentHash: String = "3debebb947a195b2af705c92972cdeda"

  public actual object strings : ResourceContainer<StringResource>, RemoteJsStringLoaderHolder {
    public actual override val __platformDetails: ResourcePlatformDetails =
        ResourcePlatformDetails()

    private val fallbackFileUrl: String =
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

    private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
        SupportedLocale("de",
            js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as
            String),
        SupportedLocale("en",
            js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as
            String),
        SupportedLocale("es",
            js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as
            String),
        SupportedLocale("fr",
            js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as
            String),
        SupportedLocale("ru",
            js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as
            String),
        ))

    public override val stringsLoader: RemoteJsStringLoader =
        RemoteJsStringLoader.Impl(supportedLocales = supportedLocales, fallbackFileUri =
        fallbackFileUrl)

    public actual override fun values(): List<StringResource> = listOf(
    CommonMainStrings0.values(),
    CommonMainStrings1.values(),
    CommonMainStrings2.values(),
    CommonMainStrings3.values(),
    CommonMainStrings4.values(),
    CommonMainStrings5.values(),
    CommonMainStrings6.values(),
    CommonMainStrings7.values(),
    CommonMainStrings8.values(),
    CommonMainStrings9.values(),
    CommonMainStrings10.values(),
    CommonMainStrings11.values(),
    CommonMainStrings12.values(),
    CommonMainStrings13.values(),
    ).flatten()
  }

  public actual object images : ResourceContainer<ImageResource> {
    public actual override val __platformDetails: ResourcePlatformDetails =
        ResourcePlatformDetails()

    public actual override fun values(): List<ImageResource> = listOf(
    CommonMainImages0.values(),
    CommonMainImages1.values(),
    ).flatten()
  }

  public actual object colors : ResourceContainer<ColorResource> {
    public actual override val __platformDetails: ResourcePlatformDetails =
        ResourcePlatformDetails()

    public actual override fun values(): List<ColorResource> = listOf(
    CommonMainColors0.values(),
    CommonMainColors1.values(),
    ).flatten()
  }

  public actual object fonts : ResourceContainer<FontResource> {
    public actual override val __platformDetails: ResourcePlatformDetails =
        ResourcePlatformDetails()

    public actual override fun values(): List<FontResource> = CommonMainFonts0.values()

    public fun addFontsToPage(): Unit {
      js("require(\"./fonts/comeladfinishbiblecontest-generated-declarations.css\")")
    }
  }

  public actual object files : ResourceContainer<FileResource> {
    public actual override val __platformDetails: ResourcePlatformDetails =
        ResourcePlatformDetails()

    public actual override fun values(): List<FileResource> = CommonMainFiles0.values()
  }

  public actual object assets : ResourceContainer<AssetResource> {
    public actual override val __platformDetails: ResourcePlatformDetails =
        ResourcePlatformDetails()

    public actual override fun values(): List<AssetResource> = listOf(
    CommonMainAssets0.values(),
    CommonMainAssets1.values(),
    CommonMainAssets2.values(),
    CommonMainAssets3.values(),
    CommonMainAssets4.values(),
    CommonMainAssets5.values(),
    CommonMainAssets6.values(),
    CommonMainAssets7.values(),
    CommonMainAssets8.values(),
    CommonMainAssets9.values(),
    CommonMainAssets10.values(),
    CommonMainAssets11.values(),
    CommonMainAssets12.values(),
    CommonMainAssets13.values(),
    CommonMainAssets14.values(),
    CommonMainAssets15.values(),
    CommonMainAssets16.values(),
    CommonMainAssets17.values(),
    CommonMainAssets18.values(),
    CommonMainAssets19.values(),
    CommonMainAssets20.values(),
    CommonMainAssets21.values(),
    CommonMainAssets22.values(),
    CommonMainAssets23.values(),
    CommonMainAssets24.values(),
    CommonMainAssets25.values(),
    ).flatten()

    public actual object allChapters

    public actual object animations

    public actual object fonts

    public actual object mikudLevels {
      public actual object adults

      public actual object youth
    }

    public actual object onqelos

    public actual object other

    public actual object pairs

    public actual object parashot

    public actual object peopleNames

    public actual object pyramid

    public actual object search

    public actual object webview
  }
}
